// extracted by mini-css-extract-plugin
export default {"comparisonPanel":"Comparison_comparisonPanel__hz-6i"};